export default {
  "content": "<circle cx=\"16\" cy=\"16.5\" r=\"16\" fill=\"#F6F6F9\"/><g clip-path=\"url(#a)\" fill=\"#717684\"><path d=\"M11 24.5H9a1 1 0 01-1-1v-8a1 1 0 011-1h2a1 1 0 011 1v8a1 1 0 01-1 1m6 0h-2a1 1 0 01-1-1v-14a1 1 0 011-1h2a1 1 0 011 1v14a1 1 0 01-1 1m6 0h-2a1 1 0 01-1-1v-11a1 1 0 011-1h2a1 1 0 011 1v11a1 1 0 01-1 1\"/></g><defs><clipPath id=\"a\"><path fill=\"#fff\" d=\"M8 8.5h16v16H8z\"/></clipPath></defs>",
  "attrs": {
    "width": "32",
    "height": "33",
    "viewBox": "0 0 32 33",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};